<div class="container renovation-container mt-5 pb-4">
    <div class="row justify-content-center">
        <div class="col-md-12 col-sm-12 col-10 container-historico">
            <h2 class="text-center mb-4">HISTÓRICO DE CONTRATOS</h2>
            <div class="table-responsive-container position-relative">
                <div class="table-responsive mb-5">
                    <table class="table table-borderless table-hover" *ngIf="contractsHistorical && contractsHistorical.length > 0">
                        <tbody>
                        <tr *ngFor="let contract of contractsHistorical | paginate: paginatorConfig" (click)="navigateToContract(contract['codContrato'])">
                            <td class="text-center font-weight-bold" scope="row">Nº Contrato {{ contract['numeroContrato'] }}</td>
                            <td class="text-center contract-description">{{contract['descripcionCorta']}}</td>
                            <td class="text-center">Renovaciones: {{contract['numRenovaciones']}}</td>
                            <td class="text-center">Vencimiento {{ contract['fechaVencimiento'] | date: "dd/MM/yyyy" }}</td>
                        </tr>
                        </tbody>
                        <tbody *ngIf="contractsHistorical.length == 0">
                        <th class="text-center">
                            <div class="spinner-border custom-loader" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </th>
                        </tbody>
                    </table>
                    <app-loader *ngIf="(showLoader || !contractsHistorical) && errormessage === ''"></app-loader>
                    <div *ngIf="errormessage" class="text-center">
                        {{ errormessage }}
                    </div>
                </div>
               
            </div>
            <app-custom-paginator *ngIf="contractsHistorical && contractsHistorical.length != 0"
                                  [elementsArray]="contractsHistorical"
                                  [paginationConfig]="paginatorConfig"></app-custom-paginator>
        </div>
    </div>
</div>
